import React from 'react';
import heroImage from '../../assets/images/whats-hot/hero-image.png';

const ProviderProfileHero: React.FC = () => {
  return (
    <div className="relative h-[200px] sm:h-[280px] md:h-[350px] lg:h-[400px] w-full overflow-hidden">
      <img
        src={heroImage}
        alt="Provider Profile Hero"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div
        className="absolute inset-0"
        style={{
          background:
            'linear-gradient(135deg, rgba(248, 232, 227, 0.9) 0%, rgba(242, 212, 200, 0.9) 25%, rgba(232, 181, 166, 0.9) 50%, rgba(214, 149, 133, 0.9) 75%, rgba(196, 117, 100, 0.9) 100%)',
        }}
      ></div>
    </div>
  );
};

export default ProviderProfileHero;
